import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Menu, Dropdown, Layout, Modal } from 'antd';
import { Link } from 'react-router-dom';
import event from '~helpers/mixpanel';

import { fireCustomEvent } from '~helpers/custom-events';
import GlobalSearch from '~components/global-search';
import {
  MyProfile as MyProfileIcon,
  Logout as LogoutIcon,
  AccountPhoto as AccountPhotoIcon,
} from '~components/svgs';

export default class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  handleHeaderTrack = clickedPosition => {
    const pathname = window?.location?.pathname ?? '';
    const isBoardPage = pathname.includes('board');

    if (isBoardPage && clickedPosition) {
      event('Clicked Herder', {
        'Page Position': 'Board',
        'Clicked Position': clickedPosition,
      });
    }
  };

  handleLinkToMyProfile = () => {
    this.handleHeaderTrack('User-My Profile');
  };

  logoutModal = () => {
    Modal.confirm({
      className: '',
      icon: <ExclamationCircleFilled />,
      title: this.props.t('cms:cms.header.dropdown.menu.log_out.modal.title'),
      okText: this.props.t('cms:cms.form.pop_confirm.yes'),
      cancelText: this.props.t('cms:cms.form.pop_confirm.no'),
      width: 380,
      onOk: () => {
        this.props.logoutUser();
      },
    });
  };

  handleLogout = () => {
    this.logoutModal();
    this.handleHeaderTrack('User-Logout');
  };

  getMenu = () => (
    <Menu style={{ width: 160, padding: 0 }}>
      <Menu.Item className="dashboard-header__menu">
        <Link
          to="/account/profile"
          onClick={this.handleLinkToMyProfile}
          className="dashboard-header__link"
        >
          <MyProfileIcon className="dashboard-header__menu-icon" />
          <span className="dashboard-header__menu-text">
            {this.props.t('cms:cms.header.dropdown.menu.my_profile')}
          </span>
        </Link>
      </Menu.Item>
      <Menu.Item className="dashboard-header__menu">
        <span onClick={this.handleLogout} role="button" tabIndex="0" style={{ outline: 0 }}>
          <LogoutIcon className="dashboard-header__menu-icon" />
          <span className="dashboard-header__menu-text">
            {this.props.t('cms:cms.header.dropdown.menu.log_out')}
          </span>
        </span>
      </Menu.Item>
    </Menu>
  );

  handleSwitchRole = () => {
    fireCustomEvent('triggerSwitchRole');
  };

  handleMsgCenter = () => {
    this.handleHeaderTrack('Chat Btn');
  };

  render() {
    const { location, history, t } = this.props;

    return (
      <Layout.Header className="dashboard-header">
        <LegacyIcon
          className="dashboard-header__trigger dashboard-header__item"
          type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'}
          onClick={this.props.toggleCollapseSidebar}
          style={{ color: '#9e9e9e' }}
        />
        <div className="dashboard-header__item dashboard-header__search">
          <If
            condition={
              location.pathname !== '/special-offers' &&
              location.pathname !== '/contract' &&
              !location.pathname.match('/locations') &&
              !location.pathname.includes('/withdrawal')
            }
          >
            <GlobalSearch
              t={this.props.t}
              pathname={location.pathname}
              search={location.search}
              history={history}
              handleHeaderTrack={this.handleHeaderTrack}
            />
          </If>
        </div>

        <div className="dashboard-header__counterOfferr-tutorial-box">
          <Link
            type="link"
            to={{
              pathname: '/new-help-center',
            }}
            target="_blank"
            className="dashboard-header__counterOfferr-tutorial"
          >
            {t('counter.offer.help_modal.tutorial_btn-title')}
          </Link>
        </div>

        <div className="dashboard-header__item dashboard-header__user-info">
          <Dropdown overlay={this.getMenu}>
            <div>
              <span className="dashboard-header__user">
                <AccountPhotoIcon className="dashboard-header__icon" />
              </span>
              <div className="dashboard-header__user-details">
                <If condition={this.props.landlordUser}>
                  <span className="dashboard-header__name">
                    {this.props.landlordUser.firstName}&nbsp;{this.props.landlordUser.lastName}
                  </span>
                </If>
              </div>
            </div>
          </Dropdown>
        </div>
      </Layout.Header>
    );
  }
}

Header.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object,
  landlordUser: PropTypes.object,
  logoutUser: PropTypes.func,
  history: PropTypes.object,
  collapsed: PropTypes.bool,
  toggleCollapseSidebar: PropTypes.func,
};

Header.defaultProps = {
  t: () => {},
  location: {},
  landlordUser: {},
  logoutUser: () => {},
  history: {},
  collapsed: false,
  toggleCollapseSidebar: () => {},
};
